/* Mewse Finder: Stacks / Styles tabs, and one card open at a time
   (for browsers that don't support <details name>). */
(function () {
  if (window.mewseFinderLoaded) return;
  window.mewseFinderLoaded = true;

  function showList(finder, key) {
    finder.querySelectorAll('[data-mw-ftab]').forEach(function (tab) {
      var on = tab.dataset.mwFtab === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    finder.querySelectorAll('[data-mw-flist]').forEach(function (list) {
      list.hidden = list.dataset.mwFlist !== key;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-mw-ftab]');
    if (!tab) return;
    showList(tab.closest('[data-mw-finder]'), tab.dataset.mwFtab);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-mw-ftab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-mw-ftab]'));
    var next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    showList(tab.closest('[data-mw-finder]'), next.dataset.mwFtab);
    next.focus();
    e.preventDefault();
  });

  // Links like /pages/discover-mewse#the-vanity-stack open that card (used by the home page teaser)
  function openFromHash() {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    var card = document.getElementById(id);
    if (!card || !card.classList.contains('mw-fcard')) return;
    var finder = card.closest('[data-mw-finder]');
    var list = card.closest('[data-mw-flist]');
    if (finder && list) showList(finder, list.dataset.mwFlist);
    var details = card.querySelector('[data-mw-fcard]');
    if (details && list) {
      list.querySelectorAll('[data-mw-fcard][open]').forEach(function (d) { if (d !== details) d.open = false; });
      details.open = true;
    }
    requestAnimationFrame(function () { card.scrollIntoView({ block: 'start' }); });
    var summary = card.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
  else openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // Fallback for browsers without exclusive <details name>: close the others in the same list
  document.addEventListener('toggle', function (e) {
    var card = e.target;
    if (!card.matches || !card.matches('[data-mw-fcard]') || !card.open) return;
    var list = card.closest('[data-mw-flist]');
    if (!list) return;
    list.querySelectorAll('[data-mw-fcard][open]').forEach(function (other) {
      if (other !== card) other.open = false;
    });
  }, true);
})();
